<template>
    <div :class="['alert fade show mb-1', 'alert-'+notice.type, (dismissible ? '' : ''),className]" role="alert" v-if="! getCookie(notice.name)">
        <span v-html="notice.message"></span>
            <a href="javascript:void(0);" class="btn btn-sm float-end btn-danger" style="margin-right: 5px;" data-bs-dismiss="alert" aria-label="Close"><i class="fa fa-times"></i> Close</a>
             <a v-if="dismissible" href="javascript:void(0);" class="btn btn-sm float-end btn-warning" style="margin-right: 5px;" @click="setCookie(notice.name, notice.name, 90)" data-bs-dismiss="alert" aria-label="Dismiss"><i class="fas fa-times-circle"></i> Dismiss</a>
    </div>
</template>

<script>
export default {
    name: "Notice",
    props: {
        notice: {required: true},
        className: { default: '' },
    },
    computed: {
        dismissible() {
            return this.notice.action == 'dismiss';
        }
    },
    methods: {
        setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        },

        getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

    }
}
</script>
